import { Navigate } from "react-router-dom";
import { useAuth } from "../context/authContext";
import { ROLE_HOME_ROUTES } from "../constants/roles";

/*
 * RoleBasedRedirect
 * -----------------
 * Mounted at "/" (the app root). It looks at the current user and forwards
 * them to their role-specific dashboard. Anonymous visitors go to /signin.
 * This keeps role-routing logic in one place so links to "/" always do the
 * right thing for the signed-in user.
 */

export default function RoleBasedRedirect() {
  const { user, isAuthenticated, isLoading } = useAuth();

  // Wait for rehydration so we don't redirect to /signin then back.
  if (isLoading) return null;

  if (!isAuthenticated || !user) {
    return <Navigate to="/signin" replace />;
  }

  return <Navigate to={ROLE_HOME_ROUTES[user.role] ?? "/signin"} replace />;
}
